import { render, staticRenderFns } from "./scenariosList.vue?vue&type=template&id=2c06ad78&"
import script from "./scenariosList.vue?vue&type=script&lang=js&"
export * from "./scenariosList.vue?vue&type=script&lang=js&"
import style0 from "./scenariosList.vue?vue&type=style&index=0&id=2c06ad78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports